import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';

import video from "../../static/video/bim.mp4";
import "./loadingScreen.scss";

const LoadingScreen = ({ setLoader, afterFunction = () => { } }) => {
    const { t } = useTranslation();
    
    useEffect(() => {
        let i = 0;
        let endTime = 10;
        const interval = setInterval(() => {
            i = i + 1;
            if (i >= endTime) {
                afterFunction();
                return setLoader((prevState) => ({
                    ...prevState,
                    signinState: 2,
                }));
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    return (
        <div className="loading_screen">
            <div className="loading_screen_content">
                <h1>{t('performing_first_time_setup')}</h1>
                <video autoPlay muted loop id="myVideo">
                    <source src={video} type="video/mp4" />
                </video>
            </div>
        </div>
    );
};

export default LoadingScreen;
